<template lang="pug">
  v-container#header(fluid)
    v-row
      v-col(d-flex xs=2 md=2 lg=2)
        router-link(to="/")
          img.logo(src="../static/logo.png")
      v-col.align-center(flex d-flex xs=5 md=5)
        v-card-title.header-title.pl-0(v-bind:class="[headerTitleClass]") {{ headerText() }}
      v-col.align-center(flex d-flex xs=5 md=5)
        v-row
          //v-btn.mx-2.short-btn.dark.bold(@click="downloadData('advisories')") Descargar datos de asesorías
          v-col.download-btns(shrink v-if="path === 'home'")
            v-btn.mr-3.short-btn.white-text.main-background.bold(@click="downloadData('advisories')") Descargar base de datos
            v-btn.border-btn.bold.userAccessBtn.text-center(outlined to="/users" v-if="userPermissions.createUser") Administrar accesos
          v-col.salir.text-right(flex d-flex v-if="path !== 'home'")
            router-link(to="/")
              p.ml-2.mr-4.bolder.main-text Regresar a Casos
          v-col.salir(flex d-flex sm=2)
            p.ml-2.mr-4.bolder(@click="logout") Salir
    v-divider

</template>

<script>
import axios from "axios";
export default {
  name: "Header",
  data() {
    return {
      headerTitleClass: ""
    };
  },
  computed: {
    userPermissions() {
      return this.$store.getters.user.permission;
    },
    path() {
      return this.$route.name;
    }
  },
  methods: {
    logout() {
      this.$router.replace("/login");
      this.$store.state.user = {
        email: null,
        role: null,
        name: null,
        isAuthenticated: true,
        permission: null
      };
      delete axios.defaults.headers.post['X-CSRF-Token'];
      delete axios.defaults.headers.delete['X-CSRF-Token'];
      delete axios.defaults.headers.put['X-CSRF-Token'];
      this.$store.dispatch("logout");
      localStorage.clear();
    },
    downloadData(type) {
      switch (type) {
        case "advisories":
          window.open(
            "https://s3.amazonaws.com/media.asesorias.cedehm.org.mx/Reportes.csv",
            "_blank"
          );
          break;
        case "victims":
          window.open(
            "https://s3.amazonaws.com/media.asesorias.cedehm.org.mx/Victimas.csv",
            "_blank"
          );
          break;
        default:
          window.open(
            "https://s3.amazonaws.com/media.asesorias.cedehm.org.mx/Reportes.csv",
            "_blank"
          );
          break;
      }
    },
    headerText() {
      switch (this.$route.name) {
        case "home":
          this.headerTitleClass = "dark-medium-text";
          return "Casos";
        case "users":
          this.headerTitleClass = "dark-medium-text";
          return "Administrar Usuarios";
        case "statistics":
          this.headerTitleClass = "main-text";
          return "Estadísticas";
        /* Against my will diseño sais no header at edition
        case "form":
          this.headerTitleClass = "dark-medium-text";
          return "Crear Caso";
        case "edit":
          this.headerTitleClass = "black-text";
          return `Editar Folio ${this.$store.state.record.folio}`;
        case "socioeconomic":
          this.headerTitleClass = "black-text";
          return `EDITAR FOLIO ${this.$store.state.record.folio}`;
        */
        default:
          this.headerTitleClass = "dark-medium-text";
          return "Casos";
      }

      return;
    }
  }
};
</script>

<style scoped lang="scss">
#header {
  .logo {
    max-width: 100%;
  }
  .download-btns {
    padding: 0px;
    display: flex;
    justify-content: flex-end;
  }
  .salir {
    padding: 0px;
    align-self: center;
    display: flex;
    justify-content: flex-end;
    p {
      text-decoration: underline;
      font-size: 17px;
      &:hover {
        cursor: pointer;
      }
    }
  }
.header-title {
    text-decoration: none;
    font-size: 47px;
    font-weight: bold;
    align-items: center;
    text-transform: uppercase;
    word-break: normal;
    line-height: 3rem;

  }

  .header-btn {
    max-width: fit-content;
    border-radius: 10px;
    border-width: 2px;
    font-family: 13px;
    font-weight: 700;
    box-shadow: none;
    height: 41px;
    width: 180px !important;
    white-space: normal !important;
    & >>> .btn__content {
      font-size: 14px;
      line-height: 15px;
    }
  }

  .short-btn {
    max-width: 217px;
    border-radius: 10px;
    font-family: 13px;
    font-weight: 700;
    box-shadow: none;
    height: 41px;
    & >>> .btn__content {
      width: 180px !important;
      white-space: normal !important;
      font-size: 14px;
      line-height: 15px;
    }
  }

  .userAccessBtn{
    color: #636363;
  }

  .align-center {
    align-self: center;
  }
}
</style>
